const config = {
    basename: 'localhost:3000',
    defaultPath: '/',
    //defaultPathNH: 'http://10.223.45.254/',
    //defaultPathGraph: 'http://10.223.45.254/api/graphql/',
    //defaultPathGraph: 'https://localhost:7056/graphql/',
    //defaultPathNH: 'http://localhost:15388',    
    fontFamily: `'Roboto', sans-serif`,
    version: '1.1.0',
    borderRadius: 12,
    ReservedWord: 'FRESENIUS|KABI|NH|CP|NUTRIHOME|CAREHOME|HOMECARE',
    ValidacionPasswordExpReg:'^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[$@!%*?&#])([a-zA-Z0-9-$@!%*?&#]{10})',
    ValidacionPasswordDescripcion:'al menos 10 carácteres (letras, números, caracter especial), 1 letra mayúscula, ' +
                                  '1 letra minúscula, 1 número y 1 caracter especial ($@!%*?&#)'
};

export default config;


